<template>
  <a-modal
      :title="title"
      :visible="visible"
      @ok="ok"
      @cancel="cancel"
      width="850px"
    >
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="false"
        rowKey="formulaId"
      >
        <a-space slot="name" slot-scope="t">
          <template slot="title">{{ t }}</template>
          {{ t }}
        </a-space>
        <span v-for="(col,i) in colKeys" :key="col" :slot="col" slot-scope="text, record">
          <cell-editor
            :background="true"
            :key="i"
            :item="record" 
            :len="1"
            :precision="1"
            :name="col"
            @blur="target => itemUpdate(target,record.formulaId,record,col)"
            :text="text"
            :attMin="col === 'inputOutputRatio' ? 0 : -999999999999.9"
            :attMax="col === 'inputOutputRatio' ? 100 : 999999999999.9"
          />
        </span>
        <template slot="x" slot-scope="t,record,i">
          <a-button @click="() => setAll(record)" :disabled="list.length <= 1" type="link">设置应用所有配方</a-button>
          <a-divider type="vertical" />
          <a-button @click="() => deleteRow(record,i)" type="link" style="color: red;">移出</a-button>
        </template>
      </a-table>
      <template slot="footer">
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" @click="ok" :disabled="list.length === 0">确定</a-button>
      </template>
    </a-modal>
</template>

<script>
import CellEditor from '../editor/CellEditor.vue'
import { nhfMixins } from "../../untils";
export default {
  components: {CellEditor},
  mixins: [nhfMixins],
  props: ['hidden','formulaIdList'],
  data() {
    return {
      title: '批量设置配销差',
      columns: [
        {
          title: "配方名称",
          dataIndex: "formulaName",
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "name" },
        },
        {
          title: "代码",
          dataIndex: "formulaCode",
          width: 120,
          align: 'center',
          ellipsis: true,
        },
        {
          title: "投入产出比(%)",
          dataIndex: "inputOutputRatio",
          width: 100,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "inputOutputRatio" },
        },
        {
          title: "净销价格(元/吨)",
          dataIndex: "netSellingPrice",
          width: 100,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "netSellingPrice" },
        },
        {
          title: "包材价格(元/吨)",
          dataIndex: "packageMaterialPrice",
          width: 100,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "packageMaterialPrice" },
        },
        {
          title: "操作",
          dataIndex: "x",
          width: 160,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "x" },
        },
      ],
      list: [],
      colKeys: ['inputOutputRatio','netSellingPrice','packageMaterialPrice'],
    }
  },
  watch: {
    visible(val){
      if(val) {
        // this.list = JSON.parse(JSON.stringify(this.formulaIdList))
        let data = {
          formulaIdList: this.formulaIdList
        }
        this.fetchPost({
          actions: this.getFormulaDistributionDiffListByIds,
          data,
          showMessage: false
        }).then(res => {
          this.list = res
        });
      }
    },
  },
  computed: {
    visible: {
      get(){
        return this.hidden
      },
      set(){}
    },
  },
  created() {},
  mounted() {},
  methods: {
    async ok(){
      // this.$emit('close',true)
      let data = {
        formulaDistributionDiffVOList: this.list
      }
      this.fetchPost({
        actions: this.batchUpdateFormulaDistributionDiff,
        data,
      }).then(() => {
        this.$emit('close',true)
      }).catch(() => {
        this.$emit('close')
      });
    },
    cancel(){
      this.$emit('close')
    },
    setAll(record){
      this.$confirm({
        title: '提示',
        content: '确认将当前数据应用到其他配方中吗？',
        cancelText: '取消',
        okText: '确定',
        onOk: async () => {
          this.list = this.list.map(el => {
            el.inputOutputRatio = record.inputOutputRatio
            el.netSellingPrice = record.netSellingPrice
            el.packageMaterialPrice = record.packageMaterialPrice
            return el
          })
        },
      })
    },
    deleteRow(record,i){
      this.$confirm({
        title: '提示',
        content: '确认将当前配方移出列表吗？',
        cancelText: '取消',
        okText: '确定',
        onOk: async () => {
          // this.list = this.list.filter(el => el.id !== record.id)
          this.list.splice(i,1)
          // this.list = this.list.splice(i,1)
        },
      })
    },
    itemUpdate(item,formulaId){
      const newData = [...this.list]
      const targets = newData.filter(item => formulaId === item.formulaId)[0]
      if (targets) {
        Object.assign(targets, item)
        this.list = newData
      }
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>